<template>
<!-- 施工管理 -->
<section class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="施工人员" name="first"/>
    <el-tab-pane label="施工工艺" name="second"/>
  </el-tabs>

  <!-- 施工人员 -->
  <div v-show="activeName=='first'">
    <div v-if="sgryDetails">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
        </div>
        <el-collapse-transition>
        <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="施工人员姓名:" label-width="50px" style="display:flex;width: 20%;margin-right: 20px;">
            <el-input v-model="sgryName" placeholder="请输入施工人员姓名" maxlength="20"/>
          </el-form-item>
          <el-form-item label="手机号码:" label-width="40px" style="display:flex;width: 20%;margin-right: 20px;">
            <el-input v-model="sgryPhone" placeholder="请输入手机号码" maxlength="11"/>
          </el-form-item>
          <el-form-item label="所属城市：" label-width="40px" style="display:flex;width: 20%;margin-right: 20px;">
            <el-cascader v-model="chengshi" placeholder="请选择城市" :options="optionsList"
            style="width: 100%" filterable clearable @change="handleChange"/>
          </el-form-item>
          <el-form-item label="状态：" label-width="30px" style="display:flex;width: 20%;margin-right: 20px;">
            <el-select v-model="isOnline" placeholder="请选择">
              <el-option v-for="(item,index) in cStatusarr" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item><el-button type="danger" @click="onSubmit()">查询</el-button></el-form-item>
        </el-form>
        </div>
        </el-collapse-transition>
      </div>
      <div class="main_container">
        <section class="model_section">
          <p class="model_top_title">施工人员</p>
          <el-button type="danger" @click="showSgryAdd()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
        </section>
        <div class="table_container">
        <el-table :data="dpsmjlList" border>
          <el-table-column label="序号" align="center" width="68px">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template scope="scope">{{scope.row.Name}}</template>
          </el-table-column>
          <el-table-column label="所属城市" align="center">
            <template scope="scope">{{scope.row.ProvinceName}}-{{scope.row.CityName}}</template>
          </el-table-column>
          <el-table-column label="手机号码" align="center">
            <template scope="scope">{{scope.row.Phone}}</template>
          </el-table-column>
          <el-table-column label="岗位" align="center">
            <template scope="scope">{{scope.row.WorkName}}</template>
          </el-table-column>
          <el-table-column label="工作年限" align="center">
            <template scope="scope">{{scope.row.WorkYear}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
            <span class="handle" @click="editSgry(scope.row)"> <i class="el-icon-edit-outline"/> 编辑 </span>
            <span style="color:#6786b4;margin-left:8px;cursor: pointer;"  @click="onshop(scope.row)" >
              <i :class="scope.row.IsOnline == 0?'el-icon-upload2':'el-icon-download'"></i>
              {{scope.row.IsOnline == 0?"上架":"下架"}}
            </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handlePagingOne"
        :current-page="pageIndex1" :page-size="10" :total="totalRowsCount1" style="float:right;margin: 10px 0;"/>
        </div>
      </div>
    </div>
    <div v-else class="main_container">
      <section class="model_section">
        <p class="model_top_title">基本信息</p>
        <!-- <el-button type="danger" @click="sgryDetails=true" style="float: right;margin: 5px 10px 0 0;">批量审核</el-button> -->
      </section>
      <el-form class="xqyForm">
        <el-form-item label="施工人员头像：" label-width="120px" style="width:35%;">
          <div v-if="pubHeadPortImg" style="width: 88px;position: relative;">
            <img src="../../assets/img/aicon36.png" @click="pubHeadPortImg=''" style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
            <el-image :src="pubHeadPortImg" class="avatar" @click="handleClickItem" :preview-src-list="[pubHeadPortImg]"/>
          </div>
          <el-upload class="avatar-uploader" action accept=".jpg, .png" v-else
          :show-file-list="false" :before-upload="beforeHeadImg">
            <i class="el-icon-plus icon-sgrytx"></i>
          </el-upload>
          <div style="color: #888;">上传图片宽高比例应为1:1，支持的图片格式，jpg、png。</div>
        </el-form-item>
        <el-form-item label="施工人员姓名：" label-width="120px" style="width:35%;">
          <el-input v-model="publisherNickName" placeholder="请输入施工人员姓名" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="手机号码：" label-width="120px" style="width:35%;">
          <el-input v-model="diaryName" placeholder="请输入手机号码" maxlength="11" style="width:90%"/>
        </el-form-item>
        <el-form-item label="工作岗位：" label-width="120px" style="width:35%;">
          <el-row>
            <el-col :span="8">
              <el-select v-model="decorationStyle" placeholder="请选择">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) in decorationStyleArr" :key="index"/>
              </el-select>
            </el-col>
            <el-col :span="14" v-show="decorationStyle == '自定义'">
              <el-input v-model="gangweiName" placeholder="请输入岗位名称（最多8个字）" maxlength="8" style="width:97%;"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="所属城市：" label-width="120px" style="width:35%;">
          <el-cascader v-model="shengshi" placeholder="请选择城市" style="width:90%"
          :options="optionDetails" filterable clearable @change="handleChangeDetails"/>
        </el-form-item>
        <el-form-item label="从业年限：" label-width="120px" style="width:35%;">
          <el-input v-model="housingArea" placeholder="请输入从业年限" style="width: 90%"/> <span style="margin-left: 10px;">年</span>
        </el-form-item>
        <el-form-item label="个人简介：" label-width="120px" style="width:50%">
          <el-input type="textarea" v-model="rContent" placeholder="纯文本框最多输入"
          :autosize="{ minRows: 3, maxRows: 6}" show-word-limit maxlength="500"/>
        </el-form-item>
      </el-form>
      <div style="text-align:center;margin-bottom: 20px;">
        <el-button @click="sgryDetails=true">取 消</el-button>
        <el-button type="danger" @click="determineSgry()" :loading="loadingBut">{{loadingButText}}</el-button>
      </div>
    </div>
  </div>
  
  <!-- 施工工艺 -->
  <div v-show="activeName=='second'">
    <div class="main_container" v-if="sggyDetails">
      <section class="model_section">
        <p class="model_top_title">施工工艺</p>
        <el-button type="danger" @click="showSggyAdd()" style="float: right;margin: 5px 10px 0 0;">新 增</el-button>
      </section>
      <div class="table_container">
        <el-table :data="ygfxhkList" border>
          <el-table-column label="序号" align="center" width="68px">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="工艺名称" align="center">
            <template scope="scope">{{scope.row.title}}</template>
          </el-table-column>
          <el-table-column label="工艺简介" align="center">
            <template scope="scope">{{scope.row.introduction}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <span class="handle" @click="editSggy(scope.row)"> <i class="el-icon-edit-outline"/> 编辑 </span>
              <span class="handle" @click="deleteData(scope.row)"> <i class="el-icon-delete"/> 删除 </span>
            </template>
        </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handlePagingTwo"
        :current-page="pageIndex2" :page-size="10" :total="totalRowsCount2" style="float:right;margin: 10px 0;"/>
      </div>
    </div>
    <div class="main_container" v-else>
      <section class="model_section">
        <p class="model_top_title">新增&编辑</p>
        <el-button type="danger" @click="sggyDetails=true" style="float: right;margin: 5px 10px 0 0;">返 回</el-button>
      </section>
      <el-form class="xqyForm">
        <el-form-item label="工艺名称：" label-width="120px" style="width:35%;">
          <el-row>
            <el-col :span="8">
              <el-select v-model="gongyimingcheng" placeholder="请选择">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) in gymcArr" :key="index"/>
              </el-select>
            </el-col>
            <el-col :span="14" v-show="gongyimingcheng == '自定义'">
              <el-input v-model="gymcName" placeholder="请输入工艺名称不超过6个字" maxlength="6" style="width:97%;"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="工艺简介：" label-width="120px" style="width:35%;">
          <el-input v-model="gyjj" placeholder="请输入介绍内容最多输入100个汉字。" maxlength="100" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="展示方式：" label-width="120px">
          <el-radio-group v-model="shopType" @change="radioType">
            <el-radio :label="1">图文</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="展示封面：" label-width="120px">
          <div v-if="coverImageUrlOne" style="width: 88px;position: relative;">
            <img src="../../assets/img/aicon36.png" @click="coverImageUrlOne=''" style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
            <el-image :src="coverImageUrlOne" class="avatar" @click="handleClickItem" :preview-src-list="[coverImageUrlOne]"/>
          </div>
          <el-upload class="avatar-uploader" action :show-file-list="false" :before-upload="beforeCoverOfDecoration" v-else>
            <i class="el-icon-plus icon-zsfm"></i>
          </el-upload>
          <div style="color: #888;">上传图片宽高比例应为1:1，支持的图片格式，jpg、png。</div>
        </el-form-item>
        <el-form-item label="展示内容：" label-width="120px" v-show="shopType == 1">
          <!-- 富文本编辑器组件 -->
          <wjEditor :desc="content1" @change="contentChangeOne" style="width:60%;"/>
        </el-form-item>
        <el-form-item label="展示内容：" label-width="120px" v-show="shopType == 2">
          <div v-if="videoSrc" class="videoClass">
            <span @click="newSeevideo(videoSrc)" class="previewingVideo">
              <img :src="videoImg" v-if="videoImg">
              <img src="../../assets/img/spfm.png" v-else>
              <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
            </span>
            <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
          </div>
          <el-upload v-else class="avatar-uploader activeUploadImg" action="" accept="video/*" :before-upload="handleFile">
            <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
        </el-form-item>
      </el-form>
      <div style="text-align:center;margin-bottom: 20px;">
        <el-button @click="sggyDetails=true">取 消</el-button>
        <el-button type="danger" @click="determineSggy()" :loading="loadingBut">{{loadingButText}}</el-button>
      </div>
    </div>
  </div>
  
  <!-- 新增弹框 -->
  <el-dialog :center="true" title="请选择装修公司" :visible.sync="dialogVisibleadd" width="30%">
    <el-form class="findform">
      <el-form-item label="装修公司：" style="display:flex;">
      <template>
        <el-select v-model="bbid" filterable placeholder="请选择装修公司">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </template>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import wjEditor from '../../components/MyWangEditor';
import { uploadOSS } from '../../utils/oss';
import { getOssFile, uploadVedio, provincegetcountys } from '../../api/newOss';
import { postInsertConstructionPersonnel, getSelectConstructionPersonnelList, postConstructionPersonnelDetailById,
  editConstructionPersonnel, constructionIsOnline, addConstructionTechnology, constructionTechnologyList,
  constructionTechnologyUpdateDetails, updateConstructionTechnology, deleteConstructionTechnology, getCompanyUser } from "../../api/shopWindow";
export default {
  name: 'construction',
  mixins: [alertTrends],
  components: { wjEditor },
  data() {
    return {
      show3: true,
      loadingBut: false,
      loadingButText: '确定',
      sgryDetails: true, // 施工人员列表页&详情页
      sggyDetails: true, // 施工工艺列表页&详情页
      activeName: 'first',
      dialogVisibleadd: false,
      options1: [],
      bbid:'',  // 店铺id
      ptyhId: '', // 平台用户id
      
      sgryName: '', // 施工人员姓名
      sgryPhone: '', // 手机号
      chengshi: '', // 所在城市
      optionsList: [], // 列表省市
      provinceId: '', // 省id
      cityId: '', // 市id
      isOnline: -1, // 状态
      cStatusarr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "已下架"
        },
        {
          Id: 1,
          Name: "已上架"
        }
      ],
      dpsmjlList: [], // 施工人员
      pageIndex1: 1,
      pageSize1: 10,
      totalRowsCount1: 0,
      sgryId: '', // 施工人员id
      
      pubHeadPortImg: '', // 施工人员头像
      publisherNickName: '', // 施工人员姓名
      diaryName: '', // 手机号码
      decorationStyle: '', // 工作岗位
      decorationStyleArr: [
        {
          id: '自定义',
          name: '自定义'
        },{
          id: '工程部总监',
          name: '工程部总监'
        },{
          id: '项目经理',
          name: '项目经理'
        },{
          id: '施工队长',
          name: '施工队长'
        },{
          id: '水电工',
          name: '水电工'
        },{
          id: '瓦工',
          name: '瓦工'
        },{
          id: '木工',
          name: '木工'
        },{
          id: '油漆工',
          name: '油漆工'
        }
      ],
      gangweiName: '', // 岗位名称
      shengshi: '', // 所在城市
      optionDetails: [],
      provinceDetailsId: 0, // 省id
      cityDetailsId: 0, // 市id
      housingArea: '', // 从业年限
      rContent: '', // 个人简介

      ygfxhkList: [], // 施工工艺
      pageIndex2: 1,
      pageSize2: 10,
      totalRowsCount2: 0,
      sggyId: '', // 施工工艺id
      
      gongyimingcheng: '', // 工艺名称前
      gymcArr: [
        {
          id: '自定义',
          name: '自定义'
        },{
          id: '强弱电工艺',
          name: '强弱电工艺'
        },{
          id: '厨卫工艺',
          name: '厨卫工艺'
        },{
          id: '油工工艺',
          name: '油工工艺'
        },{
          id: '墙体工艺',
          name: '墙体工艺'
        },{
          id: '吊顶工艺',
          name: '吊顶工艺'
        },{
          id: '水路工艺',
          name: '水路工艺'
        },{
          id: '水电改造',
          name: '水电改造'
        },{
          id: '贴砖工艺',
          name: '贴砖工艺'
        },{
          id: '油漆工艺',
          name: '油漆工艺'
        },{
          id: '开工仪式',
          name: '开工仪式'
        },{
          id: '成品保护',
          name: '成品保护'
        },{
          id: '黄墙绿地',
          name: '黄墙绿地'
        },{
          id: '水电工艺',
          name: '水电工艺'
        },{
          id: '防水工艺',
          name: '防水工艺'
        },{
          id: '瓦工工艺',
          name: '瓦工工艺'
        },{
          id: '施工进场',
          name: '施工进场'
        },{
          id: '成品保护',
          name: '成品保护'
        },{
          id: '巡查质检',
          name: '巡查质检'
        },{
          id: '地暖工艺',
          name: '地暖工艺'
        }
      ],
      gymcName: '', // 工艺名称后
      gyjj: '', // 工艺简介
      shopType: 1, // 展示方式
      // 展示封面
      coverImageUrlOne: "",
      coverImageUrlOneQiege: "",
      content1: '', // 展示内容
      
      videoImg: '', // 视频封面图
      videoSrc: "", // 视频-全连接
      videoShortSrc: "", // 视频-短链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
    }
  },
  methods: {
    // 重置
    fnReset() {
      this.sgryName = "";
      this.sgryPhone = '';
      this.chengshi = '';
      this.isOnline = -1;
    },
    // 点击tab切换
    handleClick(tab, event) {
      this.sgryPhone = '';     // 清空搜索框
      this.activeName = tab.name;
      if(tab.name=='first'){
        this.sgryDetails = true;
        this.pageIndex1 = 1;
        this.totalRowsCount1 = 0;
        this.getDpsmjl(); // 列表1
      }
      if(tab.name=='second'){
        this.sggyDetails = true;
        this.pageIndex2 = 1;
        this.totalRowsCount2 = 0;
        this.getYgfxhk(); // 列表2
      }
    },
    // 查询
    onSubmit() {
      if(this.activeName=='first'){
        this.pageIndex1 = 1;
        this.getDpsmjl();
      }
      if(this.activeName=='second'){
        this.pageIndex2 = 1;
        this.getYgfxhk();
      }
    },
    // 施工人员list
    getDpsmjl() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        userId: localStorage.Id, // 用户id
        bbId: this.bbid, // 所属的装修公司ID
        name: this.sgryName, // 施工人员姓名
        phone: this.sgryPhone, // 手机号码
        provinceId: this.provinceId, // 省份id
        cityId: this.cityId, // 城市id
        isOnline: this.isOnline, // 上架状态
        pageIndex: this.pageIndex1,// 页码
        pageSize: this.pageSize1 // 每页行数
      };
      getSelectConstructionPersonnelList(addParams).then(data => {
        if (data) {
          if (data.ResultCode == 1) {
            this.dpsmjlList = data.ResultObj;
            this.totalRowsCount1 = data.RowsCount;
          } else {
            this.dpsmjlList = [];
            this.totalRowsCount1 = 0;
          }
        } else {
          this.dpsmjlList = [];
          this.totalRowsCount1 = 0;
        }
      });
    },
    // 分页1
    handlePagingOne(val) {
      this.pageIndex1 = val;
      this.getDpsmjl();
    },
    // 施工人员-新增
    showSgryAdd() {
      if(!this.bbid) {
        this.showAlert('请先在店铺信息功能中创建自己店铺');
        return false;
      }else{
        this.sgryId = ''; // 清空施工人员id
        this.sgryDetails = false;
        this.pubHeadPortImg = '';
        this.publisherNickName = '';
        this.diaryName = '';
        this.decorationStyle = '';
        this.gangweiName = '';
        this.shengshi = '';
        this.provinceDetailsId = 0;
        this.cityDetailsId = 0;
        this.housingArea = '';
        this.rContent = '';
      }
    },
    // 施工人员-编辑回显
    editSgry(row) {
      this.sgryId = row.Id;
      this.sgryDetails = false;
      let obj = {
        id: this.sgryId, // 施工人员id
      };
      postConstructionPersonnelDetailById(obj).then(data => {
        if (data.ResultCode == 1) {
          let newObj = data.ResultObj;
          this.ptyhId = newObj.UserId; // 平台用户id
          this.pubHeadPortImg = newObj.FaceUrl; // 施工人员头像
          this.publisherNickName = newObj.Name; // 施工人员姓名
          this.diaryName = newObj.Phone; // 手机号码
          
          let gzgwName = this.decorationStyleArr.find(item => {
            return item.name === newObj.WorkName
          });
          this.decorationStyle = gzgwName?gzgwName.name:'自定义'; // 工作岗位
          this.gangweiName = newObj.WorkName; // 工作岗位名称
          this.shengshi = [newObj.ProvinceId,newObj.CityId]; // 省市回显
          this.provinceDetailsId = newObj.ProvinceId; // 省
          this.cityDetailsId = newObj.CityId; // 市
          this.housingArea = newObj.WorkYear; // 从业年限
          this.rContent = newObj.Introduction; // 个人简介
        }
      });
    },
    // 确定-施工人员
    determineSgry() {
      if (this.pubHeadPortImg == '') {
        this.showAlert('请上传施工人员头像');
        return false;
      }
      if(this.publisherNickName == ''){
        this.showAlert('请输入施工人员姓名');
        return false;
      }
      if(this.diaryName == ''){
        this.showAlert('请输入手机号码');
        return false;
      }
      if(this.decorationStyle == ''){
        this.showAlert('请选择工作岗位');
        return false;
      }
      if(this.decorationStyle == '自定义' && this.gangweiName == ''){
        this.showAlert('请输入岗位名称');
        return false;
      }
      if(this.shengshi == ''){
        this.showAlert('请选择所在城市');
        return false;
      }
      if(this.housingArea == ''){
        this.showAlert('请输入从业年限');
        return false;
      }
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      
      var addParams = {
        OperatorId: localStorage.Id, // 操作用户Id
        id: this.sgryId?this.sgryId:'', // 施工人员id
        userId: this.sgryId?this.ptyhId:'', // 平台用户id
        BbId: this.bbid, // 装修公司Id
        FaceUrl: this.pubHeadPortImg, // 施工人员头像
        Name: this.publisherNickName, // 施工人员姓名
        Phone: this.diaryName, // 手机号码
        WorkName: this.decorationStyle=='自定义'?this.gangweiName:this.decorationStyle, // 工作岗位 & 工作岗位名称
        ProvinceId: this.provinceDetailsId, // 所在城市（省）
        CityId: this.cityDetailsId, // 所在城市
        WorkYear: this.housingArea, // 从业年限
        Introduction: this.rContent, // 个人简介
      };
      let thisApi = this.sgryId?editConstructionPersonnel:postInsertConstructionPersonnel;
      thisApi(addParams).then(data => {
        if(data.ResultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.sgryDetails = true; // 隐藏详情页
          this.getDpsmjl(); // 列表1
          this.loadingBut = false;
          this.loadingButText = '确定';
        } else {
          this.showAlert(data.ResultMsg);
          this.loadingBut = false;
          this.loadingButText = '确定';
        }
      })
    },
    
    // 施工工艺list
    getYgfxhk() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbId: this.bbid, // 所属的装修公司ID
        pageIndex: this.pageIndex2,// 页码
        pageSize: this.pageSize2 // 每页行数
      };
      constructionTechnologyList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.ygfxhkList = data.resultObj.resultObj;
            this.totalRowsCount2 = data.resultObj.rowsCount;
          } else {
            this.ygfxhkList = [];
            this.totalRowsCount2 = 0;
          }
        } else {
          this.ygfxhkList = [];
          this.totalRowsCount2 = 0;
        }
      });
    },
    // 分页2
    handlePagingTwo(val) {
      this.pageIndex2 = val;
      this.getYgfxhk();
    },
    // 施工工艺-新增
    showSggyAdd() {
      if(!this.bbid) {
        this.showAlert('请先在店铺信息功能中创建自己店铺');
        return false;
      }else{
        this.sggyId = ''; // 清空施工工艺id
        this.sggyDetails = false;
        this.gongyimingcheng = '';
        this.gymcName = '';
        this.gyjj = '';
        this.shopType = 1;
        this.coverImageUrlOne = '';
        this.coverImageUrlOneQiege = '';
        this.content1 = '';
        this.videoImg='';
        this.videoSrc = '';
        this.videoShortSrc='';
      }
    },
    // 施工工艺-编辑回显
    editSggy(row) {
      this.sggyId = row.id;
      this.sggyDetails = false;
      let obj = {
        id: this.sggyId, // 施工工艺id
      };
      constructionTechnologyUpdateDetails(obj).then(data => {
        if (data.resultCode == 1) {
          let newObj = data.resultObj;
          
          let gymcName = this.gymcArr.find(item => {
            return item.name === newObj.title
          });
          this.gongyimingcheng = gymcName?gymcName.name:'自定义'; // 工艺名称
          this.gymcName = newObj.title; // 工艺名称
          this.gyjj = newObj.introduction; // 工艺简介
          this.shopType = newObj.mediaType; // 媒体类型，1=图文；2=-视频
          this.coverImageUrlOne = localStorage.BaseOssUrl + newObj.coverImg; // 展示封面-长连接
          this.coverImageUrlOneQiege = newObj.coverImg; // 展示封面-短连接
          this.content1 = newObj.content // 展示内容
          this.videoShortSrc = newObj.sourceLinks; // 视频
          this.videoSrc = this.videoShortSrc?localStorage.BaseOssUrl + newObj.sourceLinks:''; // 拼接协议头 + 视频
          
          // this.coverImageUrlOne = localStorage.BaseOssUrl + newObj.storeGiftImg; // 展示封面-全链接

        }
      });
    },
    // 确定-施工工艺
    determineSggy() {
      if(this.gongyimingcheng == ''){
        this.showAlert('请选择工艺名称');
        return false;
      }
      if(this.gongyimingcheng == '自定义' && this.gymcName == ''){
        this.showAlert('请输入工艺名称');
        return false;
      }
      if(this.gyjj == ''){
        this.showAlert('请输入工艺简介');
        return false;
      }
      if (this.coverImageUrlOne == "" || this.coverImageUrlOne == null) {
        this.showAlert('请上传展示封面');
        return false;
      }
      if(this.shopType == 1 && this.content1 == ""){
        this.showAlert('请输入展示内容');
        return false;
      }
      if(this.shopType == 2 && this.videoSrc == ""){
        this.showAlert('请上传展示内容');
        return false;
      }
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      setTimeout(()=>{
      var addParams = {
        operatorId: localStorage.Id, // 操作人id
        id: this.sggyId?this.sggyId:'', // 施工工艺id
        bbId: this.bbid, // 所属的装修公司ID
        title: this.gongyimingcheng=='自定义'?this.gymcName:this.gongyimingcheng, // 工艺名称前 & 工艺名称后
        introduction: this.gyjj, // 工艺简介
        mediaType: this.shopType, // 展示方式
        coverImg: this.coverImageUrlOneQiege, // 展示封面
        content: this.shopType == 1?this.content1:'', // 展示内容
        links: this.shopType == 1?[]:[this.videoShortSrc], // 视频
      };
      let thisApi = this.sggyId?updateConstructionTechnology:addConstructionTechnology;
      thisApi(addParams).then(data => {
        if(data.resultCode == 1) {
          this.showAlert(data.resultMsg, 'success');
          this.sggyDetails = true; // 隐藏详情页
          this.getYgfxhk(); // 列表1
          this.loadingBut = false;
          this.loadingButText = '确定';
        } else {
          this.showAlert(data.resultMsg);
          this.loadingBut = false;
          this.loadingButText = '确定';
        }
      })
      },300)
    },
    // 切换展示方式
    radioType(val) {
      this.shopType = val;
      if (this.shopType == 1) {
        this.content1 = "" // 展示内容
      } else {
        this.videoSrc = ''; // 视频
        this.videoShortSrc = '';
      }
    },
    contentChangeOne(content) {
      this.content1 = content
      // console.log(this.content1, '展示内容')
    },
    // 上架 & 下架
    onshop(row){
      this.sgryId = row.Id;
      this.$swal({
      type:'warning',
      text:row.IsOnline==0?"您确定上架此人员么?":"您确定下价架此人员么?",
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then((res) => {
        if(res.value){
          // 确定上下架
          var obj = {
            operId: localStorage.Id, // 操作人id
            id: this.sgryId, // 施工人员id
          }
          constructionIsOnline(obj).then(data=>{
            if(data.ResultCode == 1){
              this.showAlert(data.ResultMsg, 'success');
              this.getDpsmjl();
            }
          })
        }
      })
    },
    // 单条删除-列表数据
    deleteData(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          let obj = ''
          deleteConstructionTechnology(obj, row.id).then(data=>{
            if(data.resultCode == 1){
              this.showAlert(data.resultMsg, 'success');
              this.getYgfxhk();
            }
          })
        }
      })
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 详情页 所在城市
    handleChangeDetails(val) {
      this.provinceDetailsId = val[0];
      this.cityDetailsId = val[1];
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        that.optionsList = provinceAndCityAndarea;
        that.optionDetails = provinceAndCityAndarea; // 详情页省+市
      })
    },
    // 上传施工人员头像
    beforeHeadImg(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          /* oss 直传图片 */
          var obj = {
            type: 26
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.pubHeadPortImg = newOssPic;
          // that.pubHeadPortImg = newOssPic.replace(localStorage.BaseOssUrl,'')
          
        };
      }).catch(() => {
        this.showAlert('上传的图片必须是宽高比例为1:1');
      });
    },
    // 展示封面
    beforeCoverOfDecoration(file) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.showAlert('上传图片格式应为jpg/png');
        return false;
      }
      const isSize = new Promise(function(resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {
            type: 32
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.coverImageUrlOne = newOssPic;
          that.coverImageUrlOneQiege = newOssPic.replace(localStorage.BaseOssUrl,'')
        };
      },() => {
          this.showAlert('上传图片宽高比例应为1:1');
        }
      );
    },
    // 根据用户获取装修公司
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      getCompanyUser(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.gonext();
            }
            
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.getDpsmjl(); // 查询列表
      this.dialogVisibleadd = false;
    },
    // 上传视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      // oss 获取上传探店视频参数
      let obj2 = new FormData();
      obj2.append('file',file);
      uploadVedio(obj2, 6).then(data => {
        if (data.resultCode == 1) {
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'')
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.showAlert(data.resultMsg, 'error');
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      })
      
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
          // videoUrl.sources[0].src = ''
          // videoUrl.poster = ''
        }
      }).catch(() => {
        return;
      });
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    this.tankuang(); // 根据用户获取装修公司
    this.getprovince(); // 所在城市
  }
}
</script>
<style scoped>
/* 施工人员头像 */
.icon-sgrytx {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-top: 10px;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.xqyForm {
  width: 95%;
  margin: 0 auto;
}
/* 展示封面 */
.icon-zsfm {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eee;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// construction.vue?2a639d03